module.exports = __webpack_public_path__ + "img/card2.6906fe38.png";